import { html } from 'lit';
import { customElement } from 'lit/decorators';
import { DeviceAwareComponent } from './device-aware-component';

@customElement('circle-spinner')
export class CircleSpinner extends DeviceAwareComponent {

  render() {
    return html`
    <style>

      .loader:after {
        content: "";
        display: inline-block;
        font-size: 6.2px;
        border: 0.5em solid #744BDA;
        border-right-color: rgba(0,64,128, 0) !important;
        transform: translateZ(0);
        animation: spiner 1s infinite cubic-bezier(0.53, 0.21, 0.57, 0.85), colors 3s infinite cubic-bezier(0.45, -0.03, 1, 0.77);
        border-radius: 50%;
        width: 4em;
        height: 4em;
        position: absolute;
        top: 50%;
        right: 50%;
        right: calc(50% - 8em);
        margin-top: 2em;
      }



      @keyframes colors {
        0% {
          border-color: #744BDA;
          border-bottom-color: transparent;
        }
        33% {
          border-color: #3A6AA2;
          border-bottom-color: transparent;
        }
        66% {
          border-color: #3A6AA2;
          border-bottom-color: transparent;
        }
        100% {
          border-color: #5E40AA;
          border-bottom-color: transparent;
        }
      }
      @keyframes spiner {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(720deg);
        }
      }
    </style>
    <div class="loader"></div>
    `;
  }
}